export function eventPos(e) {
    if (e.touches && e.touches.length) {
        var rect = e.target.getBoundingClientRect();
        return { x: e.touches[0].pageX - rect.x, y: e.touches[0].pageY - rect.y };
    }
    if (e.changedTouches && e.changedTouches.length) {
        var rect = e.target.getBoundingClientRect();
        return { x: e.changedTouches[0].pageX - rect.x, y: e.changedTouches[0].pageY - rect.y };
    }
    return { x: e.pageX, y: e.pageY };
}
